import { ActionTypes } from "../constants/action-types";
const intialState = {
    loginData: [],
};

export const loginReducer = (state = intialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.LOGINDATARESPONSE:
            return { ...state, loginData: payload };
        default:
            return state;
    }
};
